import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9.25",
      stroke: "#D9D9D9",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92894L10 10L17.0711 17.0711Z",
      fill: "#D9D9D9"
    }, null, -1)
  ]))]))
}
export default { render: render }